<div class="dialog-header">
  <h2>Downgrade</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <!-- Plan -->
  <div class="form-group">
    <label>Plan</label>
    <select [(ngModel)]="form.plan" (ngModelChange)="onPlanChange()">
      <option *ngFor="let p of plans" [value]="p.value">{{ p.label }}</option>
    </select>
  </div>

  <!-- Current Plan Price -->
  <div class="form-group">
    <label>Current Plan Price</label>
    <input
      type="number"
      [(ngModel)]="form.currentPlanPrice"
      readonly
      class="readonly-input"
    />
  </div>

  <!-- New Plan Price -->
  <div class="form-group">
    <label>New Plan Price</label>
    <input
      type="number"
      [(ngModel)]="form.newPlanPrice"
      (ngModelChange)="calcPayBack()"
    />
  </div>

  <!-- Required Pay Back -->
  <div class="form-group">
    <label>Required Pay Back</label>
    <input
      type="number"
      [(ngModel)]="form.requiredPayBack"
      readonly
      class="readonly-input"
    />
  </div>

  <!-- Paid Back -->
  <div class="form-group">
    <label>Paid Back</label>
    <input type="number" [(ngModel)]="form.paidBack" />
  </div>

  <!-- Benefits Grid -->
  <div class="benefits-grid">
    <div class="benefit-item" *ngFor="let b of benefits">
      <label>{{ b.label }}</label>
      <input type="number" [(ngModel)]="b.value" />
    </div>
  </div>

  <!-- Attendance Schedule -->
  <div class="attendance-section">
    <div class="attendance-row" *ngFor="let day of attendanceDays">
      <div class="form-group half">
        <label>Attendance {{ day.name }} From</label>
        <input type="time" [(ngModel)]="day.from" />
      </div>
      <div class="form-group half">
        <label>Attendance {{ day.name }} To</label>
        <input type="time" [(ngModel)]="day.to" />
      </div>
    </div>
  </div>

  <!-- Note -->
  <div class="form-group">
    <label>Note</label>
    <textarea [(ngModel)]="form.note" rows="3"></textarea>
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
